<!-- src/views/RequestResetPassword.vue -->
<template>
    <v-slide-x-transition mode="out-in">
        <v-container v-if="show" style="max-width: 600px">
            <!-- header -->
            <CardTitle
                :title="$t('resetRequest.title') || 'Password reset'"
                :link="{
                    href: '/login',
                    text: $t('resetRequest.backToLogin') || 'Back to login',
                }"
            />

            <!-- card -->
            <v-card class="pa-5 mt-2">
                <v-card-text>
                    <v-form ref="form" v-model="formValid">
                        <v-text-field
                            v-model="email"
                            :label="$t('login.email')"
                            :rules="emailRules"
                            required
                        />
                    </v-form>

                    <v-alert
                        v-if="requestSent"
                        type="success"
                        variant="tonal"
                        class="mt-3"
                    >
                        {{
                            $t("resetRequest.sent") ||
                            "If that e-mail exists, a reset link has been sent."
                        }}
                    </v-alert>
                </v-card-text>

                <v-card-actions class="justify-end">
                    <v-btn
                        color="primary"
                        variant="flat"
                        :disabled="!formValid || sending"
                        @click="sendRequest"
                    >
                        {{ $t("resetRequest.send") || "Send reset link" }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-container>
    </v-slide-x-transition>
</template>

<script>
import axios from "axios";
import CardTitle from "@/components/registration/CardTitle.vue";
import { showAlertModal } from "@/utils";

export default {
    name: "RequestResetPassword",
    components: { CardTitle },
    data() {
        return {
            show: false,
            email: "",
            formValid: false,
            sending: false,
            requestSent: false,
            emailRules: [
                (v) =>
                    !!v ||
                    this.$t("login.emailRequired") ||
                    "E-mail is required",
                (v) =>
                    /.+@.+\..+/.test(v) ||
                    this.$t("login.emailInvalid") ||
                    "Invalid e-mail",
            ],
        };
    },
    mounted() {
        this.show = true;
    },
    methods: {
        showAlertModal,
        async sendRequest() {
            if (!this.$refs.form.validate()) return;

            this.sending = true;
            this.requestSent = false;
            try {
                await axios.post(
                    `${process.env.VUE_APP_API_URL}/auth/request-password-reset/`,
                    {
                        email: this.email,
                    }
                );
                this.requestSent = true;
            } catch (e) {
                console.error(e);
                this.showAlertModal(
                    this.$store,
                    this.$t("resetRequest.error"),
                    "danger",
                    12000,
                    e
                );
            } finally {
                this.sending = false;
            }
        },
    },
};
</script>

<style scoped>
/* optional custom styles */
</style>
